import React from "react";
import PropTypes from "prop-types";
import Section from "./../Section/section";
import Card from "./../Card/card";
import withMediaQueries, { mediaQueriesList } from "../../../hoc/withMediaQueries";
import RenderChildren from "../../../hoc/renderChildren";
import { contains } from "ramda";
import iconDebtConsolidation from "../../../assets/images/icon-debt-consolidation.svg";
import iconMilestones from "../../../assets/images/icon-milestones.svg";
import iconVacations from "../../../assets/images/icon-vacations.svg";
import iconHomeImprovements from "../../../assets/images/icon-home-improvements.svg";
import iconMedicalExpenses from "../../../assets/images/icon-medical-expenses.svg";
import iconMajorPurchases from "../../../assets/images/icon-major-purchases.svg";

import './uses.scss';

export const Uses = (props) => {
  const { screenSize } = props;

  const debtConsolidation = (<Card
    title="Debt consolidation"
    text={"Restructure your current debt. A Barclays Personal Loan is the perfect way to take control of your finances — with low APRs and no fees."}
    textStyling={"mx-5 pt-4 pb-5"}
    shadow={true}
    imageSrc={iconDebtConsolidation}
    imageAlt="debt consolidation icon"
    imageStyling={"mt-5 mb-2"}
  />);

  const milestones = (<Card
    title="Lifetime milestones"
    text={"Getting married? Having a baby? A Barclays Personal Loan makes paying for the important things in your life a little bit easier."}
    textStyling={"mx-5 pt-4 pb-5"}
    shadow={true}
    imageSrc={iconMilestones}
    imageAlt="lifetime milestones icon"
    imageStyling={"mt-5 mb-2"}
  />);

  const vacations = (<Card
    title="Vacations"
    text={"A dream getaway can be expensive. But with a Barclays Personal Loan, you may be able to enjoy that adventure sooner than you think."}
    textStyling={"mx-5 pt-4 pb-5"}
    shadow={true}
    imageSrc={iconVacations}
    imageAlt="vacations icon"
    imageStyling={"mt-5 mb-2"}
  />);

  const homeImprovements = (<Card
    title="Home improvements"
    text={"Flexible payment options. A Barclays Personal Loan is the perfect way to finance renovations, new appliances, and more."}
    textStyling={"mx-5 pt-4 pb-5"}
    shadow={true}
    imageSrc={iconHomeImprovements}
    imageAlt="home improvements icon"
    imageStyling={"mt-5 mb-2"}
  />);

  const medicalExpense = (<Card
    title="Medical expenses"
    text={"Rather than stress over paying out of pocket or dealing with high interest credit cards, a Barclays Personal Loan may be a simpler option."}
    textStyling={"mx-5 pt-4 pb-5"}
    shadow={true}
    imageSrc={iconMedicalExpenses}
    imageAlt="medical expenses icon"
    imageStyling={"mt-5 mb-2"}
  />);

  const majorPurchases = (<Card
    title="Major purchases"
    text={"Quick, easy, affordable. There are countless ways to use your money with a Barclays Personal Loan."}
    textStyling={"mx-5 pt-4 pb-5"}
    shadow={true}
    imageSrc={iconMajorPurchases}
    imageAlt="major purchases icon"
    imageStyling={"mt-5 mb-2"}
  />);

  const renderCardDecks = (screenSize) => {
    return contains(screenSize, [mediaQueriesList.sm.name, mediaQueriesList.md.name]) ?
      (<RenderChildren>
        <div className="card-deck uses-card-deck">
          {debtConsolidation}
          {milestones}
        </div>
        <div className="card-deck uses-card-deck">
          {vacations}
          {homeImprovements}
        </div>
        <div className="card-deck uses-card-deck">
          {medicalExpense}
          {majorPurchases}
        </div>
      </RenderChildren>)
      : (<RenderChildren>
        <div className="card-deck uses-card-deck">
          {debtConsolidation}
          {milestones}
          {vacations}
        </div>
        <div className="card-deck uses-card-deck">
          {homeImprovements}
          {medicalExpense}
          {majorPurchases}
        </div>
      </RenderChildren>);
  };

  return (
    <Section
      name="uses"
      header="Use your loan for anything you like."
      subHeader="Here are some great ideas."
      dark={true}
    >
      {renderCardDecks(screenSize)}
    </Section>
  );
};

Uses.propTypes = {
  screenSize: PropTypes.oneOf(Object.keys(mediaQueriesList))
};

export default withMediaQueries(Uses);
